import { Box, useMediaQuery, useTheme } from "@mui/material";
import EducationGraphLandscape from "components/elements/eduction_graph_landscape";
import EducationGraphPortrait from "components/elements/eduction_graph_portrait";
import { TypographyMotion } from "components/elements/material_motion";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { NAVIGATION_SET_MENU } from "utils/redux/action";

export default function EducationPage() {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const dispatcher = useDispatch();

  useEffect(() => {
    dispatcher({ type: NAVIGATION_SET_MENU, index: 1 });
  }, [dispatcher]);

  return (
    <Box
      sx={{
        position: "relative",
        padding: { xs: 0, sm: "0 10px" },
      }}
    >
      <TypographyMotion
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", delay: 0.0, duration: 1 }}
        variant="h2"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 700,
          fontSize: { xs: 20, md: 24 },
          color: "black",
          margin: 0,
        }}
      >
        Jenjang Pendidikan
      </TypographyMotion>
      {matchUpMd ? <EducationGraphLandscape /> : <EducationGraphPortrait />}
    </Box>
  );
}
